/**
 * Created by zqy on 2018/8/20 0020.
 */
const content = {
  state: {

  },
  mutations: {

  },
  actions: {

  }
}

export default content



// WEBPACK FOOTER //
// ./src/store/modules/content.js